import Autoplay from "embla-carousel-autoplay";
import useEmblaCarousel from "embla-carousel-react";
import { useCallback } from "react";

import { AUTOPLAY_OPTIONS, EMBLA_OPTIONS } from "./constants";

export const useCardsCarousel = (autoplay = true) => {
  const [emblaRef, emblaApi] = useEmblaCarousel(
    EMBLA_OPTIONS,
    autoplay ? [Autoplay(AUTOPLAY_OPTIONS)] : []
  );

  const scrollPrev = useCallback(() => emblaApi?.scrollPrev(), [emblaApi]);
  const scrollNext = useCallback(() => emblaApi?.scrollNext(), [emblaApi]);

  return { emblaRef, scrollPrev, scrollNext };
};
